import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-button-menu-item',
  templateUrl: './button-menu-item.component.html',
  styleUrls: ['./button-menu-item.component.scss'],
})
export class ButtonMenuItemComponent implements OnInit {
  @Input() icon;
  @Input() title;
  @Input() path;
  @Input() newButton;

  constructor() {}

  ngOnInit() {}

  getNewEntityPath() {
    return this.path + '/new';
  }

}
